module.exports = __webpack_public_path__ + "img/enter-tri.d2824d7d.svg";